// src/features/export/csv.ts
// Turning what a list already has on screen into a downloadable file.
//
// The rows come from the page's own state rather than from a fresh request, so
// the export is exactly the list the person is looking at — same filters, same
// order — and it costs nothing on the server.

type Cell = string | number | null | undefined;

function escapeCell(value: Cell): string {
  const text = value === null || value === undefined ? '' : String(value);
  // Quote unconditionally: a title with a comma, a newline or a quote in it is
  // the common case here, not the exception.
  return `"${text.replace(/"/g, '""')}"`;
}

export function toCsv(rows: Cell[][]): string {
  return rows.map((row) => row.map(escapeCell).join(',')).join('\r\n');
}

/** Offers `rows` to the browser as a .csv download named `filename`. */
export function downloadCsv(filename: string, rows: Cell[][]) {
  // The BOM is what makes Excel read the file as UTF-8; without it Cyrillic
  // titles arrive as mojibake.
  const blob = new Blob(['﻿', toCsv(rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/** `prefix-2026-07-30.csv` — dated so repeated exports do not overwrite. */
export function datedFilename(prefix: string): string {
  return `${prefix}-${new Date().toISOString().slice(0, 10)}.csv`;
}
